<template>
  <div class="view-options">
    <el-date-picker
      v-model="value1"
      type="daterange"
      align="right"
      unlink-panels
      range-separator="a"
      start-placeholder="Inicio"
      end-placeholder="Final"
      :picker-options="pickerOptions"
      @change="filterByDate"
    ></el-date-picker>

    <!-- <button class="icon-btn nav-export" @click="print">
      <font-awesome-icon icon="file-export" />
      <small>EXPORTAR WWW</small>
    </button>-->

    <!-- <div class="icon-btn nav-export"> -->
    <a
      class="icon-btn nav-export"
      id="downloadButton"
      download=""
      @click="download(elementId)"
    >
      <font-awesome-icon icon="file-export" />
      <small>EXPORTAR</small>
    </a>
    <!-- </div> -->
  </div>
</template>
<script>
import Swal from "sweetalert2";

import { SubscriberService } from "../services/subscriber.service";
import ExportToPdf from "../services/export_to_pdf.service";
import { mapGetters } from "vuex";
import { BUSINESS_UNIT_ID } from "../constants";

export default {
  name: "view-options",
  props: {
    elementId: String
  },
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: "Últimos 2 año",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 730);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "Ultimo año",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "Personalizado",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "ultimo mes",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "ultima semana",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      value1: [],
      value2: ""
    };
  },
  computed: {
    ...mapGetters(["date1", "date2"])
  },
  created() {
    const businessUnitId = localStorage.getItem("businessUnitId");
    const BusinessUnitIdDR = 1;
    const BusinessUnitIdPR = 2;

    this.userName = localStorage.getItem("userName");

    if (businessUnitId === BusinessUnitIdDR) {
      this.logo = "logo.svg";
    } else if (businessUnitId === BusinessUnitIdPR) {
      this.logo = "logo-axesa.svg";
    }
    const today = new Date();

    function formatDate(D) {
      const day = ("0" + D.getDate()).slice(-2);
      const month = ("0" + (D.getMonth() + 1)).slice(-2);
      const year = D.getFullYear();

      const fullDate = `${year},${month},${day}`;
      const fullDate2 = `${year}-${month}-${day}`;
      return { fullDate, fullDate2 };
    }

    const dateTodayFormat = formatDate(today);
    today.setMonth(today.getMonth() - 12);
    const lastYear = formatDate(today);

    if (screen.width <= 991) {
      this.value1 = [lastYear.fullDate, dateTodayFormat.fullDate];
      this.$store.commit("FillDate1", dateTodayFormat.fullDate2);
      this.$store.commit("FillDate2", lastYear.fullDate2);
    }
  },

  methods: {
    async download(/*elementId*/) {
      const { businessUnitId, subscriberId } = this.$route.params;
      const client = await new SubscriberService(this).getSubcriber(
        subscriberId
      );
      let downloadName = "";
      switch (Number(businessUnitId)) {
        case BUSINESS_UNIT_ID.RD:
          downloadName = `CM-${subscriberId}-${client.Name}-${this.date2} a ${this.date1}.pdf`;
          break;
        case BUSINESS_UNIT_ID.PR:
          downloadName = `Axesa_Metrics_Report-${subscriberId}-${client.Name}.pdf`;
          break;
        case BUSINESS_UNIT_ID.IP:
          downloadName = `Infometrics_Report-${subscriberId}-${client.Name}.pdf`;
          break;
        default:
          downloadName = `Report-${subscriberId}-${client.Name}.pdf`;
      }

      const HEAD_HTML = document.head.innerHTML;
      const CONTENT_HTML = document.getElementById("content").innerHTML;

      const PDF = await ExportToPdf.CallFuncToExport(
        `<head>${HEAD_HTML}</head><body>${CONTENT_HTML}</body>`
      );

      let blob = new Blob([PDF], { type: "application/pdf" });
      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = downloadName;
      link.click();
    },

    filterByDate: function(selectedDate) {
      let fromDate = String(selectedDate[0]);
      let toDate = String(selectedDate[1]);

      function formatDate(D) {
        const day = ("0" + D.getDate()).slice(-2);
        const month = ("0" + (D.getMonth() + 1)).slice(-2);
        const year = D.getFullYear();

        const fullDate = `${year}-${month}-${day}`;

        return fullDate;
      }

      const fromDateF = formatDate(new Date(`${fromDate}`));
      const toDateF = formatDate(new Date(`${toDate}`));

      if (screen.width <= 991) {
        this.$store.commit("FillDate1", toDateF);
        this.$store.commit("FillDate2", fromDateF);
      }

      let timerInterval;
      Swal.fire({
        title: "Cargando tus metricas!",
        html: `Desde ${fromDateF} hasta ${toDateF}`,
        timer: 8000,
        timerProgressBar: true,
        onBeforeOpen: () => {
          Swal.showLoading();
          timerInterval = setInterval(() => {
            Swal.getContent().querySelector(
              "b"
            ).textContent = Swal.getTimerLeft();
          }, 100);
        },
        onClose: () => {
          clearInterval(timerInterval);
        }
      }).then(result => {
        if (
          /* Read more about handling dismissals below */
          result.dismiss === Swal.DismissReason.timer
        ) {
          console.log("I was closed by the timer"); // eslint-disable-line
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.view-options {
  max-width: 1000px;
  margin: 0 auto;
  position: relative;
  margin-top: -20px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-left: -20px;
  margin-right: -20px;
  padding: 8px 20px;
  background-color: $white;
  border-bottom: $separator;
  .el-date-editor {
    width: 100%;
    max-width: 400px;
    margin: 0 auto;
  }
  .nav-export {
    display: none;
    cursor: pointer;
  }
}

@include respond-above(md) {
  .view-options {
    margin-top: -40px;
    justify-content: flex-end;
    background-color: transparent;
    padding: 0px;
    margin: 0 auto;
    border-bottom: 0;
    margin-bottom: 0px;
    margin-top: -45px;
    .el-date-editor {
      display: none;
    }
    .nav-export {
      display: flex;
      cursor: pointer;
    }
  }
}
</style>
